export interface SessionState {
   domain?: string;
   permissions?: string[];
}

export enum SessionStateActionType {
   /** Internal — use SessionContext.switchDomain() instead of dispatching directly */
   SetDomain,
   SetPermissions,
}

interface SetDomain {
   type: SessionStateActionType.SetDomain;
   domain: string;
}

interface SetPermissions {
   type: SessionStateActionType.SetPermissions;
   permissions: string[];
}

export type SessionStateActions = SetDomain | SetPermissions;
